<template>
  <div>
    <b-form @submit="onSubmit">

      <b-form-group id="eap_type" :label="$t('wifi.enterprise.eap')" label-for="eap_type">
        <b-form-select
          id="eap_type"
          v-model="form.eap"
          :options="eap_options"
          required
        ></b-form-select>
      </b-form-group>

      <b-form-group id="ca_cert" :label="$t('wifi.enterprise.ca')" label-for="ca_cert">
        <b-form-file
          id="ca_cert"
          v-model="ca_cert_file"
          :options="eap_options"
          :placeholder="$t('wifi.enterprise.fileSelect')"
          :drop-placeholder="$t('wifi.enterprise.fileDrop')"
        ></b-form-file>

      </b-form-group>

      <div v-if="form.eap === 'PEAP'">
        <b-form-group id="peap_identity" :label="$t('wifi.enterprise.peapUser')" label-for="peap_identity">
          <b-form-input
            id="peap_identity"
            v-model="form_peap.identity"
            required
            :placeholder="$t('wifi.enterprise.peapUserEnter')"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="peap_password" :label="$t('wifi.password')" label-for="peap_password">
          <b-form-input
            id="peap_password"
            v-model="form_peap.password"
            :type="passwordFieldType"
            required
            :placeholder="$t('wifi.passwordEnter')"
          ></b-form-input>
          <b-checkbox @change="onShowPassword($event)">
            {{ $t('wifi.passwordShow') }}
          </b-checkbox>
        </b-form-group>
      </div>

      <div v-if="form.eap === 'TLS'">
        <b-form-group id="tls_client_cert" :label="$t('wifi.enterprise.tlsUserCert')" label-for="tls_client_cert">
          <b-form-file
            id="tls_client_cert"
            v-model="client_cert_file"
            required
            :placeholder="$t('wifi.enterprise.fileSelect')"
            :drop-placeholder="$t('wifi.enterprise.fileDrop')"
          ></b-form-file>
        </b-form-group>

        <b-form-group id="tls_identity" :label="$t('wifi.enterprise.tlsIdentity')" label-for="tls_identity">
          <b-form-input
            id="tls_identity"
            v-model="form_tls.identity"
            :placeholder="$t('wifi.enterprise.tlsIdentityEnter')"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="tls_private_key" :label="$t('wifi.enterprise.tlsPrivKey')" label-for="tls_private_key">
          <b-form-file
            id="tls_private_key"
            v-model="private_key_file"
            :placeholder="$t('wifi.enterprise.fileSelect')"
            :drop-placeholder="$t('wifi.enterprise.fileDrop')"
          ></b-form-file>
        </b-form-group>

        <b-form-group id="tls_private_key_password" :label="$t('wifi.enterprise.tlsPrivKeyPass')" label-for="tls_private_key_password">
          <b-form-input
            id="tls_private_key_password"
            v-model="form_tls.private_key_password"
            :type="privKeyPassFieldType"
            :placeholder="$t('wifi.passwordEnter')"
          ></b-form-input>
          <b-checkbox @change="onShowPrivKeyPassword($event)">
            {{ $t('wifi.passwordShow') }}
          </b-checkbox>
        </b-form-group>
      </div>

      <b-button type="submit" variant="primary">{{ $t('wifi.connect') }}</b-button>

    </b-form>
  </div>
</template>

<script>

export default {
  name: 'SetupWifiCredentialsWPA',
  data() {
    return {
      ca_cert_file: null,
      client_cert_file: null,
      private_key_file: null,
      form: {
        encryption: 'wpa-enterprise',
        eap: 'PEAP',
        ca_cert: null,
      },
      form_peap: {
        identity: '',
        password: '',
      },
      form_tls: {
        client_cert: null,
        identity: '',
        private_key: null,
        private_key_password: '',
      },
      eap_options: [
        {value: 'PEAP', text: 'PEAP'},
        {value: 'TLS', text: 'TLS'},
      ],
      passwordFieldType: 'password',
      privKeyPassFieldType: 'password',
    }
  },
  watch: {
    ca_cert_file(val) {
      if (!val) return;
      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        this.form.ca_cert = e.target.result;
      };
      fileReader.readAsText(this.ca_cert_file);
    },
    client_cert_file(val) {
      if (!val) return;
      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        this.form_tls.client_cert = e.target.result;
      };
      fileReader.readAsText(this.client_cert_file);
    },
    private_key_file(val) {
      if (!val) return;
      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        this.form_tls.private_key = e.target.result;
      };
      fileReader.readAsText(this.private_key_file);
    }
  },
  methods: {
    onSubmit() {
      var config = {};
      if (this.form.eap == 'PEAP') {
        config = Object.assign({}, this.form, this.form_peap);
      } else {
        config = Object.assign({}, this.form, this.form_tls);
      }

      var files = ['ca_cert', 'client_cert', 'private_key'];
      files.forEach((key) => {
        if (config[key] === null) {
          delete config[key];
        }
      });

      this.$emit('connect', config);
    },
    onShowPassword(val) {
      this.passwordFieldType = val ? 'text' : 'password';
    },
    onShowPrivKeyPassword(val) {
      this.privKeyPassFieldType = val ? 'text' : 'password';
    }
  }
}
</script>
